import request from './index';

export function getHomeSectionOrder(params) {
  return request.get('officialHomeSection/list', { params });
}

export function saveHomeSectionOrder(data) {
  return request.post('officialHomeSection/save', data);
}

export function updateHomeSectionOrder(data) {
  return request.post('officialHomeSection/update', data);
}
